import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {ErrorsStackService} from '../errors-stack.service';

/**
 * Guard пускает на страницу, только если в стеке ошибок Runtime есть ошибки
 */
@Injectable()
export class OnlyIfErrorsService implements CanActivate {

    constructor(
        private errorsStackService: ErrorsStackService,
        private router: Router,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        /**
         * Забираем ошибки из сервиса, храняшего ошибки
         * @type {any}
         */
        const error = this.errorsStackService.errors$.getValue();

        if (error) {
            return true;
        } else {
            this.router.navigate(['/']);
            return false;
        }
    }
}
